import { patterns } from './../../../../../lib/formly/patterns';
import { TranslateService } from '@ngx-translate/core';
import { AllInputTypes, FormInputConfig, ListValues } from '../../../../../trash/shared/interfaces/form-input-config';
import { getIdFormConfig } from '../../../../../views/pages/adminstration/temp-common/utils';
import { ICreateUserRequest } from '../dtos';
import { Validators } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';

export class CreateUserModel implements ICreateUserRequest {
  email: string;
  firstName: string;
  lastName: string;
  password: string;

  private constructor(request: ICreateUserRequest) {
    this.email = request.email;
    this.firstName = request.firstName;
    this.lastName = request.lastName;
    this.password = request.password;
  }

  static create(request: ICreateUserRequest): CreateUserModel {
    return new CreateUserModel(request);
  }

  static createDefault(): CreateUserModel {
    return new CreateUserModel({
      email: '',
      firstName: '',
      lastName: '',
      password: '',
      specializedRoles: [],
      systemRoles: []
    });
  }

  getFormConfig(roles: ListValues[], isVisible?: boolean, translate?: TranslateService): FormInputConfig[] {
    return [
      // getIdFormConfig(this.id),
      {
        type: AllInputTypes.Text,
        name: 'firstName',
        label: translate?.instant('FORMS.FIRST_NAME'),
        placeholder: `${translate?.instant('FORMS.EX')} ${translate?.instant('FORMS.FIRST_NAME')}`,
        defaultValue: '',
        isDisable: false,
        widthClass: 'col-12',
        validation: [
          {
            function: Validators.required,
            errorMessage: `${translate?.instant('GENERAL.PLEASE_ENTER')} ${translate?.instant('FORMS.FIRST_NAME')}`
          }
        ]
      },
      {
        type: AllInputTypes.Text,
        name: 'lastName',
        label: translate?.instant('FORMS.LAST_NAME'),
        placeholder: `${translate?.instant('FORMS.EX')} ${translate?.instant('FORMS.LAST_NAME')}`,
        defaultValue: '',
        isDisable: false,
        widthClass: 'col-12',
        validation: [
          {
            function: Validators.required,
            errorMessage: `${translate?.instant('GENERAL.PLEASE_ENTER')} ${translate?.instant('FORMS.LAST_NAME')}`
          }
        ]
      },
      {
        type: AllInputTypes.Email,
        name: 'email',
        label: translate?.instant('FORMS.EMAIL'),
        placeholder: `${translate?.instant('FORMS.EX')} email@email.com`,
        defaultValue: '',
        isDisable: false,
        widthClass: 'col-12',
        validation: [
          {
            function: Validators.required,
            errorMessage: `${translate?.instant('GENERAL.PLEASE_ENTER')} ${translate?.instant('FORMS.EMAIL')}`
          },
          {
            function: Validators.email,
            errorMessage: `${translate?.instant('GENERAL.PLEASE_ENTER')} ${translate?.instant('FORMS.VALID_EMAIL')}`
          }
        ]
      },
      {
        type: AllInputTypes.MultiSelect,
        name: 'specializedRoles',
        label: translate?.instant('GENERAL.ROLES'),
        placeholder: translate?.instant('GENERAL.SELECT'),
        widthClass: 'col-12',
        listValues: roles
        // defaultValue: this.formValues?.specializedRoles
      },
      {
        type: AllInputTypes.Password,
        name: 'password',
        label: translate?.instant('FORMS.PASSWORD'),
        placeholder: `${translate?.instant('FORMS.EX')} P@ssw0rd`,
        widthClass: 'col-md-12',
        defaultValue: '',
        validation: [
          {
            function: Validators.required,
            errorMessage: `${translate?.instant('GENERAL.PLEASE_ENTER')} ${translate?.instant('FORMS.PASSWORD')}`
          }
        ]
      },
      {
        type: AllInputTypes.Password,
        name: 'confirmPassword',
        label: translate?.instant('FORMS.CONFIRM_PASSWORD'),
        placeholder: `${translate?.instant('FORMS.EX')} P@ssw0rd`,
        widthClass: 'col-md-12',
        defaultValue: '',
        validation: [
          {
            function: Validators.required,
            errorMessage: `${translate?.instant('GENERAL.PLEASE_ENTER')} ${translate?.instant('FORMS.CONFIRM_PASSWORD')}`
          }
        ]
      }
    ];
  }

  getFormlyConfig(translate: TranslateService, isVisible?: boolean): FormlyFieldConfig[] {
    return [
      {
        fieldGroupClassName: 'row',
        fieldGroup: [
          {
            className: 'col-12 mb-3',
            type: 'input',
            key: 'firstName',
            props: {
              label: translate?.instant('FORMS.ADMIN_FIRST_NAME'),
              placeholder: `${translate?.instant('GENERAL.ENTER')} ${translate?.instant('FORMS.ADMIN_FIRST_NAME')}`,
              required: true,
              defaultValue: this.firstName,
              disabled: !isVisible
            },
            validation: {
              messages: {
                required: `${translate?.instant('GENERAL.PLEASE_ENTER')} ${translate?.instant('FORMS.ADMIN_FIRST_NAME')}`
              }
            }
          },
          {
            className: 'col-12 mb-3',
            type: 'input',
            key: 'lastName',
            props: {
              label: translate?.instant('FORMS.ADMIN_LAST_NAME'),
              placeholder: `${translate?.instant('GENERAL.ENTER')} ${translate?.instant('FORMS.ADMIN_LAST_NAME')}`,
              required: true,
              defaultValue: this.lastName,
              disabled: !isVisible
            },
            validation: {
              messages: {
                required: `${translate?.instant('GENERAL.PLEASE_ENTER')} ${translate?.instant('GENERAL.ADMIN_LAST_NAME')}`
              }
            }
          },
          {
            className: 'col-12 mb-3',
            type: 'input',
            key: 'email',
            props: {
              label: translate?.instant('FORMS.ADMIN_EMAIL'),
              placeholder: `${translate?.instant('GENERAL.ENTER')} ${translate?.instant('FORMS.ADMIN_EMAIL')}`,
              required: true,
              defaultValue: this.email,
              pattern: patterns.email,
              disabled: !isVisible
            },
            validation: {
              messages: {
                required: `${translate?.instant('GENERAL.PLEASE_ENTER')} ${translate?.instant('GENERAL.ADMIN_EMAIL')}`,
                pattern: translate.instant('FORMS.VALID_EMAIL')
              }
            }
          },
          {
            type: 'input',
            key: 'password',
            className: 'col-12 mb-4',
            props: {
              label: translate.instant('FORMS.ADMIN_PASSWORD'),
              placeholder: `${translate.instant('GENERAL.ENTER')} ${translate.instant('FORMS.ADMIN_PASSWORD')}`,
              defaultValue: this.password,
              required: true,
              type: 'password'
            },
            validation: {
              messages: {
                required: `${translate.instant('GENERAL.PLEASE_ENTER')} ${translate.instant('FORMS.ADMIN_PASSWORD')}`
              }
            }
          }
        ]
      }
    ];
  }
}
